import { render } from "./PanelLawyerCardAndBio.vue?vue&type=template&id=051ca713&scoped=true"
import script from "./PanelLawyerCardAndBio.vue?vue&type=script&lang=js"
export * from "./PanelLawyerCardAndBio.vue?vue&type=script&lang=js"

import "./PanelLawyerCardAndBio.vue?vue&type=style&index=0&id=051ca713&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-051ca713"]])

export default __exports__